<template>
    <v-select
        v-model="model"
        :label="`Vessel Type${required ? ' *' : ''}`"
        :items="ALL_VESSEL_TYPES"
        @update:modelValue="syncVModel"
        item-title="title"
        item-value="value"
        @blur="$emit('blur')"
    ></v-select>
</template>

<script lang="ts" setup>
import type { VesselTypes } from '@geckoal/gecko-api-client'
import { ref, watch, type PropType } from 'vue'
import { ALL_VESSEL_TYPES } from '../../lib/vesselTypes'

const props = defineProps({
    modelValue: {
        type: String as PropType<VesselTypes>
    },
    required: {
        type: Boolean
    }
})

const model = ref<VesselTypes | undefined>()

watch(
    () => props.modelValue,
    (value) => {
        model.value = value
    },
    { immediate: true }
)

const emit = defineEmits(['update:modelValue', 'blur'])

const syncVModel = () => {
    emit('update:modelValue', model.value)
}
</script>
